<div class="flex-col-container justify-between">
  <div class="flex-row-container items-center justify-between mb-16">
    <mat-icon>error</mat-icon>
    <div><strong> {{ 'GLOBAL.ERRORS.SERVICE_ERROR' | translate }} </strong></div>
  </div>
  <div class="end fs-12" *ngFor="let error of data">{{ error.status }}: {{ error.statusText }} [{{error.errorCode}}]</div>
</div>
